import { useEffect, useRef, useState } from 'react';

export const HideDropdown = () => {
  const ref = useRef();
  const [visible, setVisible] = useState('block');

  const handleClickOutside = e => {
    if (ref && !ref.current.contains(e.target)) {
      setVisible('none');
    }
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
  }, [ref]);

  return { visible, setVisible, ref };
};
